import { Menu } from 'lucide-react';
import {
  IDEIcon,
  VSCodeIcon,
  CursorIcon,
  WindsurfIcon,
  WarpIcon,
  ClaudeIcon,
  ClineIcon,
} from './IDEIcon';

interface TerminalHeaderProps {
  onClear: () => void;
}

export function TerminalHeader({ onClear }: Readonly<TerminalHeaderProps>) {
  return (
    <div className="bg-[#0f0f0f] border-b border-[#2a2a2a] px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-3">
        {/* macOS-style traffic lights */}
        <div className="flex gap-2">
          <div className="w-3 h-3 rounded-full bg-[#ff5f56]"></div>
          <div className="w-3 h-3 rounded-full bg-[#ffbd2e]"></div>
          <div className="w-3 h-3 rounded-full bg-[#27c93f]"></div>
        </div>
        <button
          onClick={onClear}
          className="text-cyan-400 font-mono hover:text-cyan-300 transition-colors cursor-pointer"
        >
          MIFTA
        </button>
      </div>

      <div className="hidden md:flex items-center gap-4 text-gray-500 text-sm">
        <span>works with</span>
        <div className="flex items-center gap-3">
          <IDEIcon name="VS Code" icon={<VSCodeIcon />} hoverColor="#007ACC" />
          <IDEIcon name="Cursor" icon={<CursorIcon />} hoverColor="#6366F1" />
          <IDEIcon
            name="Windsurf"
            icon={<WindsurfIcon />}
            hoverColor="#06B6D4"
          />
          <IDEIcon
            name="Claude Code"
            icon={<ClaudeIcon />}
            hoverColor="#D97757"
          />
          <IDEIcon name="Warp" icon={<WarpIcon />} hoverColor="#00D4AA" />
          <IDEIcon name="Terminal" icon={<ClineIcon />} hoverColor="#10B981" />
        </div>
      </div>

      <button className="hidden text-gray-400 hover:text-white transition-colors">
        <Menu className="w-5 h-5" />
      </button>
    </div>
  );
}
